import { FileActionButton } from "../file-action/file-action-controls";
import React, { useMemo } from "react";
import * as XLSX from "xlsx";

export type RouteForExport = {
  driverId?: number;
  totalDistanceKm?: number;
  drivingMinutes?: number;
  driverName?: string;
  phonenumber?: string;
  ordersInRoute: Array<{ orderId?: string; sequence?: number }>;
  vehicleNo?: string; 
};

type Props = {
  routes: RouteForExport[];
  fileName?: string;
  label?: string;
  className?: string;
  style?: React.CSSProperties;
};

export default function ExportRoutesExcel({
  routes,
  fileName,
  label = "Export to Excel",
  className,
  style,
}: Props) {
 
  const rows = useMemo(() => {
    return routes.flatMap((r) =>
      r.ordersInRoute.map((o, idx) => {
        const seq = typeof o.sequence === "number" ? o.sequence : NaN;
        const sequence = Number.isFinite(seq) && seq > 0 ? seq : idx + 1;
        return {
          "Order ID": o.orderId ?? "",
          "Driver Mobile": r.phonenumber ?? "",
          "Driver Name": r.driverName ?? "",
          "Sequence": sequence,
          "Vehicle No": r.vehicleNo ?? "",
        };
      })
    );
  }, [routes]);

  const handleClick = () => {
    if (rows.length === 0) {
      alert("No routed stops to export.");
      return;
    }
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Routes");
    const name =
      fileName ?? `routes_export_${new Date().toISOString().slice(0, 10)}.xlsx`;
    XLSX.writeFile(wb, name);
  };

  return (
    <FileActionButton action="export"
      icon="pi pi-download"
      onClick={handleClick}
      //disabled 
      disabled={rows.length === 0}
      className={className}
      style={{
        padding: "0.6rem 0.9rem",
        fontWeight: "bold",
        ...style,
      }}
      tooltip={rows.length === 0 ? "Nothing to export yet" : label}
      tooltipOptions={{ position: "top" }}
      aria-label="Download Excel"
    />
  );
}


